<template>
  <router-view />
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    console.log(this.$store.state)
    let sidebar = [
      {
        name: "统计",
        children: [
          { name: "社区统计", router: "statistics" },
          { name: "运行监控", router: "monitor", isNewWindow: true }
        ],
        showChild: false,
        isShow:1
      },
      {
        name: "居民",
        children: [
          { name: "居民管理", router: "userCitizen" },
          { name: "党员先锋", isShow: false, router: "vanguard" },
          { name: "志愿之星", isShow: false, router: "star" }
        ],
        showChild: false,
        isShow:1
      },
      {
        name: "企业",
        children: [
          { name: "企业管理", router: "userEnterprise" },
          { name: "广告发布", router: "advert" }
        ],
        showChild: false,
        isShow:1
      },
      {
        name: "社工",
        router: "userSocialWorker",
        isShow:1
      },
      {
        name: "组织",
        router: "organize",
        isShow:1
      },
      {
        name: '部门',
        router: 'Department',
        isShow: 1
      },
      {
        name: "资源服务",
        router: "shareList",
        isShow:1
      }
    ];
    this.$store.commit("updateSideList", sessionStorage.getItem('managerList') ?  JSON.parse(sessionStorage.getItem('managerList') ): this.$store.state.managerList);
  },
  methods: {},
  components: {}
};
</script>

<style></style>
